import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SingleSelectorComponent } from '@shared/single-selector/single-selector.component';
import { DirectivesModule } from '@directives/directives.module';
import { SingleSelectorService } from '@shared/single-selector/single-selector.service';
import { TextFieldModule } from '@angular/cdk/text-field';
import { OrderListSheetSheetModule } from '@shared/bottom-sheet-layouts/order-list/order-list.module';
import { MultiProductSelectionSheetModule } from '@shared/bottom-sheet-layouts/multi-product-selection/multi-product-selection-sheet.module';
import { ButtonCtaComponent } from '@components/button-cta/button-cta.component';

@NgModule({
  providers: [SingleSelectorService],
  imports: [CommonModule, DirectivesModule, FormsModule, TextFieldModule, OrderListSheetSheetModule, MultiProductSelectionSheetModule, ButtonCtaComponent],
  declarations: [SingleSelectorComponent],
  exports: [SingleSelectorComponent],
})
export class SingleSelectorModule {}
